import { useEffect, useState } from "react"

type TUseRowSelectParams<T> = {
  data?: T[]
  initialSelectAll?: boolean
}

export const useRowSelect = <T>({
  data,
  initialSelectAll = false,
}: TUseRowSelectParams<T>) => {
  const [rowSelection, setRowSelection] = useState({})

  useEffect(() => {
    if (initialSelectAll && data && data.length > 0) {
      const allRowIds = Object.fromEntries(
        data.map((_, index) => [index, true]),
      ) as Record<number, boolean>

      setRowSelection(allRowIds)
    }
  }, [data, initialSelectAll])

  const getSelectedItems = (): T[] => {
    if (!data || !data.length || Object.keys(rowSelection).length === 0)
      return []

    return Object.keys(rowSelection).reduce<T[]>((acc, key) => {
      const reward = data[Number(key)]

      if (reward) acc.push(reward)

      return acc
    }, [])
  }

  return {
    rowSelection,
    setRowSelection,
    getSelectedItems,
  }
}
